import React, {Component} from "react";
import ModalContainer from "../../../../../modules/commons/ModalContainer";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import withFormGroup from "../../../../../modules/commons/withFormGroup";
import FlexView from "react-flexview";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import {mapToObjectDDL} from "../../../../common/mapper";

class MasterLogistikMotorSeriesModifying extends Component {
    handleSubmit = () => {
        if (this.props.validate()) {
            this.props.onSubmit(this.props.controls);
        }
    };

    render() {
        return (
            <SimpleModal
                title="Form Series"
                visible={this.props.visible}
                onClickClose={() => this.props.onClickClose()}
                content={
                    <ModalContainer>
                            <ModifyingDDL
                                id="select_options_segmen_"
                                name="idSubSegment"
                                text="Sub Segmen"
                                mandatory
                                errorMessage={this.props.errors.idSubSegment}
                                options={this.props.dataSubSegmenDDL}
                                value={
                                    this.props.controls && Object.keys(this.props.controls).length > 0
                                        ? mapToObjectDDL(
                                            this.props.controls.idSubSegment.value.label,
                                            this.props.controls.idSubSegment.value.value,
                                        )
                                        : undefined
                                }
                                onChange={(value, {name}) =>
                                    this.props.setValue(name, value)
                                }
                            />

                            <SimpleInput
                                id="input_text_series"
                                name="seriesName"
                                label="Nama Series"
                                mandatory
                                errorMessage={this.props.errors.seriesName}
                                value={this.props.controls.seriesName.value}
                                onChange={({target}) =>
                                    this.props.setValue(target.name, target.value)
                                }
                            />
                            <div style={{textAlign: "center"}}>
                                <SimpleButton onClick={this.handleSubmit}>Simpan</SimpleButton>
                            </div>
                    </ModalContainer>
                }
            />
        )
    }
}

export default withFormGroup(MasterLogistikMotorSeriesModifying);

class ModifyingDDL extends Component {
    render() {
        return (
            <FlexView column hAlignContent="center" style={{flex: 1}}>
                <SimpleDDL
                    containerclassname="margin-botton-5px width width-full"
                    box="search"
                    isSearchable={true}
                    isClearable
                    options={this.props.options}
                    label={this.props.text}
                    {...this.props}
                />
            </FlexView>
        );
    }
}